import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    payload: Object,
  }

  connect() {
    window.parent.postMessage(this.payloadValue, "*")
  }
}
